import { DialogContent } from "@mui/material";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { DocumentSubmissionRejectedBottomSheetContent } from "./RejectedContent";

interface DocumentSubmissionRejectedBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentSubmissionRejectedBottomSheet(
  props: DocumentSubmissionRejectedBottomSheetProps
) {
  const { modalState } = props;
  const location = useLocation<{ title?: string; description?: string }>();
  const title = location.state?.title;
  const description = location.state?.description;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet header={<BottomSheetHeader onClose={handleClose} />} modalState={modalState}>
      <DialogContent sx={{ paddingX: 5 }}>
        <DocumentSubmissionRejectedBottomSheetContent title={title} description={description} />
      </DialogContent>
    </BottomSheet>
  );
}
